import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

import Modal from '@/views/common/Modal';

import {
  Box, Button, styled, Typography,
} from '@datanomik/commons-ui';

import { useWorkspaceContext } from '@/contexts/workspace';
import { useKeycloakContext } from '@/contexts/keycloak/context';

import { styles } from './styles';

const WorkspaceEmptyModalRaw = ({ className }) => {
  const { logoutKeycloak } = useKeycloakContext();
  const { workspace: { handleCloseEmptyWorkspace, openEmptyWorkspace } } = useWorkspaceContext();

  const handleRedirect = () => {
    handleCloseEmptyWorkspace();
    logoutKeycloak();
  };

  return (
    <Modal
      openModal={openEmptyWorkspace}
      backdropClose={false}
      title="Workspaces"
      DialogProps={{
        maxWidth: 'xs',
        PaperProps: {
          sx: { minWidth: '400px' },
        },
      }}
      DialogHeaderProps={{
        text: t('Workspaces'),
      }}
      DialogActionsProps={{
        dialogActions: (
          <Button
            variant="contained"
            onClick={handleRedirect}
            fullWidth
          >
            {t('Log out')}
          </Button>
        ),
      }}
    >
      <Box className={className}>
        <Typography variant="p5" color="text.500">
          {t('You do not have assigned workspaces')}
        </Typography>
      </Box>
    </Modal>
  );
};

const WorkspaceEmptyModal = styled(WorkspaceEmptyModalRaw)(styles);

WorkspaceEmptyModalRaw.propTypes = {
  className: PropTypes.string,
};

WorkspaceEmptyModal.propTypes = WorkspaceEmptyModalRaw.propTypes;

export default WorkspaceEmptyModal;
